export enum RecordCallOption {
  YES = "yes",
  NO = "no",
}

export enum SecureCallStatus {
  CREATED = "created",
  WAITING_FOR_SEND = "waiting_for_send",
  SENDING = "sending",
  BLOCKED = "blocked",
  FAILED = "failed",
  ANSWERED = "answered",
  BUSY = "busy",
  REJECTED = "rejected",
  NO_ANSWER = "no_answer",
  DEVICE_OFF = "device_off",
  INVALID_NUMBER = "invalid_number",
  UNREACHABLE = "unreachable",
  CANCELED = "canceled",
}

export interface RecordingFile {
  name: string;
  caption: string;
  original_name: string;
  mime_type: string;
  url: string;
  size: number;
  type: string;
  length: number;
}

export interface SecureCallSchema {
  id: number;
  workspace_id: number;
  pbx_server_id: number;
  pbx_trunk_id: number;
  access_token_id: number;
  first_side_number: string;
  second_side_number: string;
  scheduled_time: string | null;
  sent_time: string | null;
  start_time: string | null;
  answer_time: string | null;
  end_time: string | null;
  waiting_seconds: number;
  billable_seconds: number;
  duration_seconds: number;
  max_duration_seconds: number;
  cost_interval_amount: number;
  cost_interval_value: number;
  estimated_duration: number;
  estimated_cost: number;
  actual_duration: number;
  actual_cost: number;
  unique_id: string | null;
  record_call: RecordCallOption;
  status: SecureCallStatus;
  created_at: string;
  updated_at: string;
  recording_file_id: number | null;
  recording_file: null | RecordingFile;
}
